import React from 'react'
import NumberFormat from 'react-number-format'
import xType from 'xtypejs'

export function calculateFileSize(size) {
  if (size >= 1024) {
    if (size >= (1024 * 1024)) {
      return `${((size / 1024) / 1024).toFixed(2)} MB`
    }
    return `${(size / 1024).toFixed(2)} KB`
  } else {
    return `${size.toFixed(2)} Bytes`
  }
}

export function getMismatchObjectsBetweenTwoArray(a, b) {
  let mismatch = []
    let matches = false

    for ( let i = 0; i < a.length; i++ ) {
      matches = false
      for ( let e = 0; e < b.length; e++ ) {
        if ( a[i] === b[e] ) matches = true
      }
      if(!matches) mismatch.push( a[i] )
    }
    return mismatch
}

export function scrollToFirstValidateFailElement(errors) {
  var elementName = findFirstElementName(errors)
  if (elementName) {
    let elements = document.getElementsByName(elementName)
      if (elements.length) {
        elements[0].parentElement.parentElement.parentElement.scrollIntoView()
        return false
      }
      return true
  }

  // if (errors) {
  //   Object.keys(errors).every((x, i) => {
  //     let firstKey = Object.keys(errors)[i]
  //     let elements = document.getElementsByName(firstKey)
  //     if (elements.length) {
  //       elements[0].parentElement.parentElement.parentElement.scrollIntoView()
  //       return false
  //     }
  //     return true
  //   })
  // }
}

const findFirstElementName = (data) => {

  const getFieldName = (errors) => {
    if (xType(errors) !== 'empty_object' && xType(errors).includes('object')) {
      let firstKey = ''
      if (Object.keys(errors).length > 0) {
        firstKey = Object.keys(errors)[0]
      }
      return firstKey ? `.${firstKey}` + getFieldName(errors[firstKey]) : ''
    } else if (xType(errors) !== 'empty_array' && xType(errors).includes('array')) {
      var index = null
  
      errors.forEach((x, i) => {
        if (index === null) {
          var fName = getFieldName(x)
        }
  
        if (fName !== '') {
          index = i
        }
      }) 
  
      return index !== null ? `[${index}]` + getFieldName(errors[index]) : ''
    } else {
      return ''
    }
  }

  var fieldName = getFieldName(data)

  return fieldName.startsWith('.') ? fieldName.substring(1) : fieldName
}

export const getOptionTitle = (options, value) => {
  if (value !== undefined) {
    const opt = options && options.find(o => o.value === value)
    return opt ? opt.text : value
  } else {
    return ''
  }
}

export const numberFormat = (value, allowNegative = false, decimalScale=2) => {
  return (
  <NumberFormat 
    className='centerContent' 
    thousandSeparator=',' 
    value={value} 
    displayType='text'
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    fixedDecimalScale />
  )
}

export const isNullOrEmpty = (value) => {
  return value === undefined || value === null || value === ''
}

export const currencyNumberFormat = (number = 0, currency = null, minimumFractionDigits = 2) => {
  if (currency) {
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: currency,
      minimumFractionDigits: minimumFractionDigits,
    }).format(number)
  }

  return new Intl.NumberFormat('en-Us', {minimumFractionDigits: minimumFractionDigits}).format(number)
}

export const discountCalculator = (price, discount, type='percent') => {
  if (type === 'percent') {
    return price - (price * discount / 100)
  }

  return price - discount
}

export const mathRoundDigit = (number=0, digit=2) => {
  if (number != 0) {
    return (Math.round(number * 100) / 100).toFixed(digit)
  }else{
    return 0
  }
}

export const stringToFunction = (formula) => {
  return eval(formula)
}

export const validateEmail = (input='') => {
  let validRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  let emailValid = true
  let emailSet = input.split(';')
  console.log('emailSet',emailSet)

  emailSet.forEach(x => {
    if (!x.match(validRegex)) {
      emailValid = false
    }
  });
  return emailValid
}
